import StrapiLayoutPage from "./StrapiLayoutPage";

export * from "./StrapiLayoutPage";
export default StrapiLayoutPage;
